/* file description */

import { useState } from 'react';
import type { UseAddRecordWrap } from './type';

export const useAddRecordWrap: UseAddRecordWrap = () => {
  const [addRecordWrapVisible, setAddRecordWrap] = useState<boolean>(false);
  return {
    addRecordWrapVisible,
    setAddRecordWrap,
  };
};
